import React, { useContext } from "react";
import { Grid, Typography, Box, useMediaQuery } from "@mui/material";
import { BaseButton } from "../../../common/base-button/base-button";
import saman from "../../../../assets/imgs/saman.jpg";
import pasargad from "../../../../assets/imgs/pasargad.png";
import keshavarzi from "../../../../assets/imgs/keshavarzi.png";
import { InfoCircle } from "iconsax-react";

import axios from "axios";
import { toast } from "react-toastify";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";
import BASE_URL from "../../../../constants/baseUrls";

const maskCardNumber = cardNumber => {
    // Mask the card number: show the first 4 and last 4 digits, mask the middle
    return cardNumber.replace(/^(\d{4})\d{8}(\d{4})$/, "$1****$2");
};

const cardOptions = [
    { cardNumber: "6037697500345464", id: 1, image: saman },
    { cardNumber: "5047061029384756", id: 2, image: pasargad },
    { cardNumber: "6273841093847561", id: 3, image: keshavarzi },
];

const DepositRefundOptions = ({ closeModal, selectedCard, selectedCardId, refundAmount }) => {
    const { locale } = useContext(LocaleContext);
    // Responsive styles
    const IS_MOBILE = useMediaQuery("(max-width:600px)");
    const accessToken = localStorage.getItem("accessToken");
    const { t } = useTranslation();

    const handleConfirmClick = async () => {
        try {
            const params = {
                amount: refundAmount,
                card_id: selectedCardId,
            };
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            };

            // API request
            const response = await axios.get(`${BASE_URL}/api/v2/account/user/refund-balance/`, {
                headers,
                params,
            });

            // Access response data directly
            const data = response.data;

            // Success check based on status and data structure
            if (response.status === 200 && data?.data?.tracking_code) {
                const trackingCode = data.data.tracking_code;
                toast.success(t("Toast Messages.Request Registered", { trackingCode }));
                closeModal(); // This should now work correctly
            } else {
                // Unsuccessful but with a 200 status
                toast.error(data?.message || t("Toast Messages.Error Occurred"));
            }
        } catch (error) {
            // Enhanced error handling
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    // Server responded with a non-2xx status code
                    const errorMessage = error.response.data?.message || error.response.data?.error || "خطا در ارسال درخواست.";
                    toast.error(errorMessage);
                } else if (error.request) {
                    // Request made but no response received
                    toast.error(t("Toast Messages.Connectivity Issue"));
                } else {
                    // Something happened in setting up the request that triggered an Error
                    toast.error(error.message || t("Toast Messages.Error Occurred"));
                }
            } else {
                // Non-Axios error, such as a code bug or network issue
                toast.error(t("Toast Messages.Unexpected Error"));
            }
            console.error("Error in handleConfirmClick:", error);
        }
    };
    return (
        <Box
            sx={{
                textAlign: "center",
                margin: "auto",
                width: "100%",
                maxWidth: IS_MOBILE ? "100%" : "400px",
                padding: IS_MOBILE ? "16px" : "24px",
            }}
        >
            <Grid container spacing={2}>
                {/* Title */}
                <Typography
                    variant="h6"
                    component="h2"
                    align="center"
                    gutterBottom
                    sx={{
                        fontSize: IS_MOBILE ? "16px" : "18px",
                        fontWeight: 500,
                    }}
                >
                    تأیید اطلاعات
                </Typography>
                {/* Description */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "8px",
                        bgcolor: "grey.100",
                        padding: "12px",
                        gap: "1rem",
                    }}
                >
                    <InfoCircle size={32} />
                    <Typography
                        align="center"
                        gutterBottom
                        sx={{
                            fontSize: IS_MOBILE ? "12px" : "14px",
                            marginBottom: "24px",
                            textAlign: "left",
                        }}
                    >
                        لطفا اطلاعات زیر را جهت واریز وجه به دقت بررسی کرده و اقدام لازم را انجام دهید.
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        padding: "16px",
                        textAlign: "center",
                        marginBottom: "16px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontSize: IS_MOBILE ? "12px" : "14px",
                            color: "#777",
                        }}
                    >
                        مبلغ
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: IS_MOBILE ? "14px" : "18px",
                                fontWeight: "bold",
                            }}
                        >
                            {refundAmount}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: IS_MOBILE ? "12px" : "16px",
                                color: "#777",
                            }}
                        >
                            ریال
                        </Typography>
                    </Box>
                </Box>

                {/* Card Number Information */}
                <Box
                    sx={{
                        width: "100%",
                        padding: "16px",
                        textAlign: "center",
                        marginBottom: "16px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontSize: IS_MOBILE ? "12px" : "14px",
                            color: "#777",
                        }}
                    >
                        شماره کارت
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: IS_MOBILE ? "14px" : "18px",
                                fontWeight: "bold",
                                direction: locale === "ar" || locale === "fa" ? "rtl" : "ltr",
                            }}
                        >
                            {/* {maskCardNumber(cardOptions[0].cardNumber)} */}
                            {maskCardNumber(selectedCard)}
                        </Typography>
                        <img src={cardOptions[0].image} alt="Card" width={40} height={25} style={{ marginRight: "8px" }} />
                    </Box>
                </Box>

                {/* Confirm Button */}
                <BaseButton
                    text=" تأیید اطلاعات"
                    color="secondary"
                    size={IS_MOBILE ? "medium" : "large"} // Adjust button size for mobile
                    radius="radius-10"
                    handleClick={handleConfirmClick}
                />
            </Grid>
        </Box>
    );
};

export default DepositRefundOptions;
